import { Button } from '@ps/isp-web-component-library';
import { useTrackers } from '@ps/web-shared-analytics';
import { Link, Translation, useTrackingLabel } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTWCL_Convert_Funds } from './ConvertFundsButton.messages.json';

const convertPath = '/account/cashier/convert-currencies';

const ConvertFundsButton: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { buttonPressed } = useTrackers();
  const buttonName = useTrackingLabel(TXTWCL_Convert_Funds);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const cashierHref = useSelector(select.cms.getCashierHref);

  return (
    <Button
      as={isEmbedded ? Link : undefined}
      href={cashierHref}
      onClick={() => {
        buttonPressed({ buttonName });
        !isEmbedded && modal.enqueue({ path: convertPath });
      }}
      size="medium"
    >
      <Translation {...TXTWCL_Convert_Funds} />
    </Button>
  );
};

export default ConvertFundsButton;
